import { logOut, optOut } from '@heimdall/client';
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { rigSharedStyles } from './heimdall-rig-styles.js';

@customElement('heimdall-rig-logout')
export class HeimdallRigLogout extends LitElement {
  @state() _lane: string | undefined;

  onLaneChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    this._lane = target.value || undefined;
  }

  render() {
    return html`
      <div class="app">
        <h2>Logout${this._lane ? ` (${this._lane})` : ''} (HCL version)</h2>
        <ul>
          <li>
            <label>Lane</label>
            <input
              type="text"
              @change=${this.onLaneChanged}
              .value=${this._lane || ''}
              placeholder="lane or empty for 'base'"
            />
          </li>
          <li>
            <button @click=${() => logOut({ lane: this._lane })}>
              Log out
            </button>
            ∷
            <button @click=${() => optOut({ lane: this._lane })}>
              Opt out
            </button>
          </li>
        </ul>
      </div>
    `;
  }

  static styles = rigSharedStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-rig-logout': HeimdallRigLogout;
  }
}
